'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HighlightedComment = function HighlightedComment(_ref) {
  var backgroundColor = _ref.backgroundColor,
      lineColor = _ref.lineColor,
      size = _ref.size;

  var maskId = 'highlighted-comment-mask-icon-' + new Date().getTime();
  return _react2.default.createElement(
    'svg',
    { width: size, height: size, viewBox: '0 0 20 20' },
    _react2.default.createElement(
      'defs',
      null,
      _react2.default.createElement('path', { d: 'M1.5 8.965c0 2.736 1.47 5.148 3.706 6.588.595.378-1.037 3.186-.357 3.42.901.305 4.14-2.034 5.151-2.034 4.692 0 8.5-3.573 8.5-7.974S14.692 1 10 1 1.5 4.564 1.5 8.965' })
    ),
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: 1, fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement(
        'mask',
        { id: '' + maskId, fill: '#fff' },
        _react2.default.createElement('path', { d: 'M1.5 8.965c0 2.736 1.47 5.148 3.706 6.588.595.378-1.037 3.186-.357 3.42.901.305 4.14-2.034 5.151-2.034 4.692 0 8.5-3.573 8.5-7.974S14.692 1 10 1 1.5 4.564 1.5 8.965' })
      ),
      _react2.default.createElement('path', {
        d: 'M1.5 8.965c0 2.736 1.47 5.148 3.706 6.588.595.378-1.037 3.186-.357 3.42.901.305 4.14-2.034 5.151-2.034 4.692 0 8.5-3.573 8.5-7.974S14.692 1 10 1 1.5 4.564 1.5 8.965',
        fill: '#F06361'
      }),
      _react2.default.createElement(
        'g',
        { mask: 'url(#' + maskId + ')', fill: backgroundColor },
        _react2.default.createElement('rect', { x: 0, y: 0, width: size, height: size })
      ),
      _react2.default.createElement('path', {
        d: 'M13.16 6.128c.232 0 .421.106.421.24v.585c0 .133-.189.24-.42.24H6.548c-.231 0-.42-.107-.42-.24v-.586c0-.133.189-.24.42-.24h6.613zm0 2.403c.232 0 .421.107.421.24v.585c0 .133-.189.24-.42.24H6.548c-.231 0-.42-.107-.42-.24v-.585c0-.133.189-.24.42-.24h6.613zm-3.439 2.404c.232 0 .426.106.42.24v.585c0 .133-.188.24-.42.24H6.548c-.231 0-.42-.107-.42-.24v-.586c0-.133.189-.24.42-.24h3.173z',
        fill: lineColor,
        mask: 'url(#' + maskId + ')'
      })
    )
  );
};

HighlightedComment.defaultProps = {
  backgroundColor: '#F7C51E',
  lineColor: '#FFFFFF',
  size: 20
};

HighlightedComment.propTypes = {
  backgroundColor: _propTypes2.default.string,
  lineColor: _propTypes2.default.string,
  size: _propTypes2.default.number
};

exports.default = HighlightedComment;